module.exports = __webpack_public_path__ + "01_medium_brown.b53f2b54.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/01_medium_brown.png
// module id = Gqke
// module chunks = 0